/**
 * @class
 */
import Base from 'netxcore@netx/core-cms/models/CMSAction';
import {currentPortalPages} from '@netx/core-cms/singletons/currentPortalPages';

export default class CMSAction extends Base {
	/** @override */
	parse(result, opts) {
		if (!_.isObject(result) && _.isNumeric(result)) {
			// This is the server-side unique id.  We don't use it client-side, but it doesn't hurt.
			this.set({id: result});
			return;
		}

		this.set(this.unpackAttrs(result), opts);

		// the dam returns link, menuview works on route
		// the dam returns page number, clean works on slug
		const type = this.get('type');
		if (type == 'page') {
			// if it's a page, set the route to the page slug
			const pageId = this.get('link').match(/#page\/(.*)/)[1];
			const page = currentPortalPages.get(pageId);
			if (page) {
				const slug = page.get('slug');
				this.set('route', `page/${slug}`);
			}
		} else if (type == 'url') {
			// if it's a url, when the route ends up an empty string it routes to #
			// instead of following the 'link' attribute
			this.set('route', null);
		} else {
			// category or asset
			this.set('route', this.get('link'));
		}

		// register in global namespace so it can actually act as an actionable action
		this.register();

		return this.attributes;
	}
}
